import Vue from 'vue'
import { IonicVueRouter } from "@ionic/vue";
import TagList from './views/tag/List.vue'
import Search from './views/Search.vue'
import ContentNew from './views/content/New.vue'
import Dashboard from './views/Dashboard.vue'
import Export from './views/Export.vue'
import BoxList from './views/box/List.vue'
import BoxEdit from "./views/box/Edit";
import LinkNew from "./views/link/New";
import LinkEdit from "./views/link/Edit";
import LinkList from "./views/link/List";
import BoxNew from "./views/box/New";
import ContentEdit from "./views/content/Edit";
import ConfigEdit from "./views/config/Edit";
import ConfigList from "./views/config/List";

Vue.use(IonicVueRouter);

export default new IonicVueRouter({
  routes: [
    {
      path: '/tag/list',
      name: 'TagList',
      component: TagList
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/box/edit/:id',
      name: 'BoxEdit',
      component: BoxEdit
    },
    {
      path: '/config/list',
      name: 'ConfigList',
      component: ConfigList
    },
    {
      path: '/content/edit/:id',
      name: 'ContentEdit',
      component: ContentEdit
    },
    {
      path: '/config/edit/:id',
      name: 'ConfigEdit',
      component: ConfigEdit
    },
    {
      path: '/box/new/',
      name: 'BoxNew',
      component: BoxNew
    },
    {
      path: '/link/new/:box',
      name: 'LinkNew',
      component: LinkNew
    },
    {
      path: '/link/edit/:box/:id',
      name: 'LinkEdit',
      component: LinkEdit
    },
    {
      path: '/link/list/:box',
      name: 'LinkList',
      component: LinkList
    },
    {
      path: '/export',
      name: 'export',
      component: Export
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/box/list',
      name: 'BoxList',
      component: BoxList
    },
    {
      path: '/content/new',
      name: 'ContentNew',
      component: ContentNew
    }
  ]
})
